var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParticles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 465.28 464.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m285.49,0c-79.88,0-150.95,53.65-172.84,130.49l-.09.31L8.55,234.82C3.08,240.28.08,247.53.08,255.24s3.01,14.95,8.47,20.41c5.23,5.23,12.67,8.22,20.41,8.22s15.19-3,20.41-8.22l59.97-59.97.51,2.33c5.14,23.66,14.95,45.8,29.16,65.82l.64.9L8.47,415.91c-5.46,5.46-8.47,12.71-8.47,20.41s3.01,14.95,8.47,20.41,12.67,8.22,20.41,8.22,15.19-3,20.41-8.22l131.17-131.17.89.63c19.87,14.18,42.02,23.99,65.83,29.16l2.33.51-59.97,59.97c-5.46,5.46-8.47,12.71-8.47,20.41s3.01,14.95,8.47,20.41c5.23,5.23,12.67,8.22,20.41,8.22s15.19-3,20.41-8.22l103.88-103.88.56-.16c76.81-21.96,130.46-93.03,130.46-172.83C465.28,80.65,384.63,0,285.49,0Zm0,57.76c67.28,0,122.02,54.74,122.02,122.02s-54.74,122.02-122.02,122.02-122.02-54.74-122.02-122.02,54.74-122.02,122.02-122.02Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticles);
export default __webpack_public_path__ + "static/media/particles.524461375747a692193080c084b2d5a9.svg";
export { ForwardRef as ReactComponent };